<template>
  <div class="feedback-wrap">
    <div class="action-container">
      <el-button
        @click.prevent="clickUp"
        class="upOrDownButton"
        :class="
          (hasSubmit && upAlreadyClicked) || (!hasSubmit && upAlreadyClicked)
            ? 'is-active'
            : ''
        "
        size="mini"
      >
        <img
          class="agree-icon"
          :src="(hasSubmit && upAlreadyClicked) || (!hasSubmit && upAlreadyClicked) ? agreeActiveIcon : agreeIcon"
        />
        <span>已解决</span>
      </el-button>
      <el-button
        @click.prevent="openFeedback"
        class="upOrDownButton"
        :class="
          (hasSubmit && downAlreadyClicked) ||
          (!hasSubmit && downAlreadyClicked)
            ? 'is-active'
            : ''
        "
        size="mini"
      >
        <img
          class="agree-icon"
          :src="(hasSubmit && downAlreadyClicked) || (!hasSubmit && downAlreadyClicked) ? agreeNorActiveIcon : agreeNorIcon"
        />
        <span>未解决</span>
      </el-button>
    </div>
    <Drawer
      :visible="show"
      @close="handleCancel"
      title="未解决"
      :show-cancel="false"
    >
      <div class="tag-container">
        <div
          v-for="(tag, index) in tags"
          :key="index"
          class="tag-item"
          :class="{ active: selectedTag === tag }"
          @click="onSelectTag(tag)"
        >
          {{ tag.name }}
        </div>
      </div>
      <template #cancel>
        <img
          :src="drawerCloseIcon"
          @click="handleCancel"
          class="drawer-close-icon"
        />
      </template>
      <template #footer>
        <button
          class="submit-button"
          @click="handleSubmit"
          :disabled="!selectedTag"
        >
          提交
        </button>
      </template>
    </Drawer>
  </div>
</template>

<script>
import api from '@/api/api.js'
import Drawer from '@/components/mobile/drawer'
import drawerCloseIcon from '@/assets/image/drawer_close.png'
import agreeIcon from '@/assets/image/solution_agree.png'
import agreeActiveIcon from '@/assets/image/solution_agree_active.png'
import agreeNorIcon from '@/assets/image/solution_agree_nor.png'
import agreeNorActiveIcon from '@/assets/image/solution_agree_nor_active.png'


// 1-点赞 2-点踩
const COMMENT_TYPE = {
  UP: 1,
  DOWN: 2,
}
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    sign: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: {
    Drawer,
  },
  data() {
    return {
      selectedTag: '',
      upAlreadyClicked: false,
      downAlreadyClicked: false,
      show: false,
      hasSubmit: false,
      isSubmitting: false,
      drawerCloseIcon,
      agreeIcon,
      agreeActiveIcon,
      agreeNorIcon,
      agreeNorActiveIcon,
    }
  },
  methods: {
    onSelectTag(tag) {
      if (this.hasSubmit) return
      this.selectedTag = tag
    },
    handleCancel() {
      if (this.hasSubmit) return
      this.selectedTag = ''
      this.downAlreadyClicked = false
      this.show = false
    },
    handleSubmit() {
      if (this.hasSubmit) return
      if (!this.selectedTag) {
        this.$store.commit('showMessage', {
          message: '请先选择',
          type: 'error',
        })
        return
      }
      if (this.selectedTag) {
        this.submitFeedback({
          comment: this.selectedTag.name,
          comment_type: COMMENT_TYPE.DOWN,
        })
      }
    },
    openFeedback() {
      if (this.isSubmitting || this.hasSubmit) return
      this.downAlreadyClicked = true
      this.upAlreadyClicked = false
      this.show = true
    },
    clickUp() {
      if (this.hasSubmit || this.isSubmitting) return
      this.upAlreadyClicked = true
      this.downAlreadyClicked = false
      this.show = false
      this.submitFeedback({
        comment_type: COMMENT_TYPE.UP,
      })
    },

    async submitFeedback(params) {
      if (this.hasSubmit || this.isSubmitting) return
      this.isSubmitting = true
      const res = await api.addRobotKnowComment({
        sign: this.sign,
        know_name: this.name,
        know_id: this.id,
        ...params,
      })
      this.isSubmitting = false
      if (res) {
        this.$store.commit('showMessage', {
          message: '感谢您的反馈！',
          type: 'success',
        })
        this.hasSubmit = true
        this.show = false
      } else {
        this.$store.commit('showMessage', {
          message: `${res.msg || '提交失败'}`,
          type: 'error',
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.feedback-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
// 容器样式
.feedback-container {
  width: 100%;
  .px2rem(padding-top, 16);
  background-color: #fff;
  .px2rem(border-radius, 8);
  border: 1px solid #dedede;
}

// 标签容器
.tag-container {
  display: flex;
  flex-wrap: wrap;
  .px2rem(gap, 12);
  .px2rem(margin-bottom, 20);
  justify-content: space-around;
  .px2rem(padding-bottom, 50);
}

// 标签项样式
.tag-item {
  .px2rem(padding-left, 12);
  .px2rem(padding-right, 12);
  .px2rem(padding-top, 8);
  .px2rem(padding-bottom, 8);
  color: rgba(26, 29, 37, 0.85);
  .px2rem(border-radius, 6);
  .px2rem(font-size, 14);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #f5f7fa;
  background-color: #f5f7fa;
  .px2rem(min-width, 100);
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.active.tag-item {
  background-color: #fff;
  color: #2290fd;
  border: 1px solid #2290fd;
}

// 操作按钮容器
.action-buttons {
  display: flex;
  border-top: 1px solid #e8e8e8;
}

// 取消按钮
.cancel-button {
  flex: 1;
  .px2rem(padding, 12);
  background-color: transparent;
  color: rgba(26, 29, 37, 0.85);
  border: none;
  .px2rem(font-size, 16);
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #409eff;
  }
}

// 提交按钮
.submit-button {
  display: flex;
  border-radius: 8px;
  .px2rem(height, 44);
  background: rgba(26, 29, 37, 1);
  color: #fff;
  border: none;
  .px2rem(font-size, 16);
  cursor: pointer;
  transition: color 0.3s ease;
  justify-content: center;
  align-items: center;
  .px2rem(width, 327);
  margin: 0 auto;
  .px2rem(margin-bottom, 12);
  //   &:hover:not(:disabled) {
  //     color: #66b1ff;
  //   }

  &:disabled {
    color: rgba(26, 29, 37, 0.3);
    background-color: rgba(0, 0, 0, 0.1);
    cursor: not-allowed;
  }
}

.is-plain {
  color: #2290fd;
}
.upOrDownButton {
  border: none;
  border-radius: 0;
  margin-left: 0 !important;
  flex: 1;
  box-sizing: border-box;
  border: 1px solid rgba(233, 234, 237, 1);
  border-radius: 8px;
  .px2rem(height, 32);
  color: #5c606a;

  &:hover {
    color: #606266;
  }

  ::v-deep(span) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
}
.upOrDownButton:hover {
  background-color: #fff;
}

.upOrDownButton.is-active {
  background-color: #fff;
  color: #2290fd;
  border: 1px solid #2290fd;
}

.action-container {
  .px2rem(height, 60);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .px2rem(column-gap, 12);
}

::v-deep(.iconfont) {
  .px2rem(margin-right, 6);
}

.drawer-close-icon {
  .px2rem(width, 24);
  .px2rem(height, 24);
  .px2rem(right, 24);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.agree-icon{
  display: block;
  .px2rem(width, 16);
  .px2rem(margin-right, 6);
}
</style>
